import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class GetEntity extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("entityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("entityPk", params, DataTypes.assertObject);
  }

  [RUN](params) {
    const entity = this.app.getEntity(params.entityType, params.entityPk);
    return entity;
  }
}
Routine.register("GetEntity", GetEntity);
